<h1 mat-dialog-title><span *ngIf="editMode">Save</span><span *ngIf="!editMode">Add</span> Fire Report</h1>
<div mat-dialog-content>
  <form [formGroup]="fireForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col">
          <label class="formLabel" for="AGENCY_NAME">Agency</label>
          <select formControlName="AGENCY_ID">
            <option *ngFor="let item of agencyList" [value]="item.AGENCY_ID">{{item.NAME}}</option>
          </select>
      </div>
      <div class="col">
          <label class="formLabel" for="REPORT_NUMBER">Report #</label>
          <input type="number" formControlName="REPORT_NUMBER">
      </div>
    </div>

    <div class="row">
      <div class="col">
          <label class="formLabel" for="REPORT_DATE">Report Date</label>
          <input [owlDateTime]="REPORT_DATE" [owlDateTimeTrigger]="REPORT_DATE" formControlName="REPORT_DATE">
          <owl-date-time #REPORT_DATE></owl-date-time>
          <!--<input type="datetime-local" formControlName="REPORT_DATE">-->
      </div>
      <div class="col">
          <label class="formLabel" for="LOG_DATE">Log Date</label>
         <!-- <input type="date" formControlName="LOG_DATE">-->
         <input [owlDateTime]="LOG_DATE" [owlDateTimeTrigger]="LOG_DATE" formControlName="LOG_DATE">
         <owl-date-time [pickerType]="'calendar'" #LOG_DATE></owl-date-time>

      </div>
    </div>

    <div class="row">
      <div class="col">
          <label class="formLabel" class="formLabel" for="TYPE_ID">Type of Fire</label>
          <select formControlName="TYPE_ID">
            <option *ngFor="let item of typeList" [value]="item.TYPE_ID">{{item.DESCRIPTION}}</option>
          </select>
      </div>
      <div class="col">
          <label class="formLabel" class="formLabel" for="CAUSE_ID">Cause of Fire</label>
          <select formControlName="CAUSE_ID">
            <option *ngFor="let item of causeList" [value]="item.CAUSE_ID">{{item.DESCRIPTION}}</option>
          </select>
      </div>
    </div>

    <div class="row">
      <div class="col">
          <label class="formLabel" for="FIRE_PERIOD">Date/Time of Fire</label>
          <!--<input type="text" formControlName="FIRE_PERIOD">-->
          <input [owlDateTime]="FIRE_PERIOD" [owlDateTimeTrigger]="FIRE_PERIOD" formControlName="FIRE_PERIOD">
          <owl-date-time #FIRE_PERIOD></owl-date-time>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="SITE">Site</label>
          <select formControlName="SITECODE">
            <option *ngFor="let x of sites"
            [value]="x.SITECODE">{{x.NAME}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="BUILDING">Location</label>
          <bats-bldg-lookup formControlName="LOCATION"></bats-bldg-lookup>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="INJURY_COUNT"># Injuries</label>
          <input type="number" formControlName="INJURY_COUNT">
      </div>
      <div class="col">
          <label class="formLabel" for="DEATH_COUNT"># Deaths</label>
          <input type="number" formControlName="DEATH_COUNT">
      </div>
    </div>

    <div class="row">
      <div class="col">
          <label class="formLabel" for="PROPERTY_DAMAGE">Est Property Damage</label>
          <select  formControlName="PROPERTY_DAMAGE">
            <option value='$0-99'>$0-99</option>
            <option value='$100-999'>$100-999</option>
            <option value='$1,000-9,999'>$1,000-9,999</option>
            <option value='$10,000-24,999'>$10,000-24,999</option>
            <option value='$25,000-49,999'>$25,000-49,999</option>
            <option value='$50,000-99,999'>$50,000-99,999</option>
            <option value='$100,000-249,999'>$100,000-249,999</option>
            <option value='$250,000-499,999'>$250,000-499,999</option>
            <option value='$500,000-999,999'>$500,000-999,999</option>
            <option value='>$1,000,000'>>$1,000,000</option>
          </select>
      </div>
    </div>

    <div mat-dialog-actions>
      <button class="dialog-button btn-success" type="button" *ngIf="editMode" (click)="copyFire()">Copy</button>
      <button class="dialog-button" type="button" (click)="closeDialog()">Close</button>
      <button class="dialog-button btn-danger" *ngIf="editMode" type="button" (click)="deleteFire()">Delete</button>
      <button class="dialog-button" type="submit" [disabled]="!fireForm.valid">
        Save
        <span class="btn-danger ml-2 px-3" ngbTooltip="Number of reports that already exist with this report number" *ngIf="numberOfReports > 0">
          {{numberOfReports}}
        </span>
      </button>
    </div>
  </form>
</div>
